import React from "react";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// local
import BehaviouralForm from "./BehaviouralForm";
import BehaviouralJournalForm from "./BehaviouralJournalForm";
import BehaviouralContainer from "./BehaviouralContainer";
import Filters from "./Filters";

// redux
import { useSelector } from "react-redux";

const Behavioural = () => {
  const behavioural = useSelector((state) => state.behavioural);
  const auth = useSelector((state) => state.auth);

  const isSuperAdmin = auth.user?.role === "superadmin";

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Grid container>
        <Grid item xs={12}>
          <MDBox py={3} pl={1}>
            <MDBox className="card bg-gradient-default" p={3} borderRadius="lg">
              <MDTypography variant="h5" color="white" fontWeight="medium">
                Instruction
              </MDTypography>
              <MDTypography variant="button" color="white" sx={{ display: "block", mt: 1 }}>
                Rate today&apos;s sleep, food, mood and activity out of 10. Saving again the same
                day updates your existing entry — this info feeds the behavioural report on your
                dashboard.
              </MDTypography>
            </MDBox>
          </MDBox>
        </Grid>

        <Grid item xs={12}>
          <BehaviouralForm />
        </Grid>

        <Grid item xs={12}>
          <MDBox py={3} pl={1}>
            <BehaviouralJournalForm />
          </MDBox>
        </Grid>

        {isSuperAdmin && (
          <>
            <Grid item xs={12}>
              <MDBox py={3} pl={1}>
                <Filters />
              </MDBox>
            </Grid>
            <Grid item xs={12}>
              <MDBox py={3} pr={1}>
                <BehaviouralContainer behaviourals={behavioural.behaviourals} />
              </MDBox>
            </Grid>
          </>
        )}
      </Grid>
    </DashboardLayout>
  );
};

export default Behavioural;
